import React, {Component, Fragment} from 'react';
import {Form, Input, InputGroup, Label, Button, ButtonGroup, FormGroup} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import * as work from 'customers/actions/work';
import Loading from 'apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import Date from 'apa/components/Date';
import {ChangeYear} from 'invoices/Options';
import {getToday} from 'invoices/containers/InvoiceDetail';


@connect(
	null,
	dispatch => {
		return {
			remove: worklog => dispatch(work.remove(worklog))
		}
	}
)
export class DeleteWorkModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isDeleteWorkModalOpen: false
		}

	}

	render() {
		return (
			<Fragment>

				<Button color='danger' onClick={this.toggleDeleteModal}>
					<i className='fa fa-trash'> </i>
				</Button>
				<Dialog
					isOpen={this.state.isDeleteWorkModalOpen}
					confirm={this.confirmDelete}
					toggle={this.toggleDeleteModal}
					title={'Arbeit löschen'}
				>
						Sind Sie sicher?
			</Dialog>
		</Fragment>
		)
	}

	@autobind
	confirmDelete() {
		this.props.remove(this.props.work);
		this.toggleDeleteModal()
		this.props.confirm()
	}

	@autobind
	toggleDeleteModal() {
		this.setState(
			{
				isDeleteWorkModalOpen: !this.state.isDeleteWorkModalOpen
			}
		)
	}
}

@connect(
	state => (
		{
			auth: state.apa
		}
	)
)
export class EditWorkModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			work: props.work,
			customer: props.customer
		}
	}

	@autobind
	toggle() {
		this.setState(
			{
				isOpen: !this.state.isOpen
			}
		)

	}

	@autobind
	confirm() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const body = JSON.stringify(
			this.state.work
		);
		fetch(
			`/api/work/${this.state.work.id}/`,
			{headers, method: 'PATCH', body}
		).then(
			res => res.json()
		).then(
			work => {
				this.props.confirm(work);
				this.toggle();
			}
		);
	}

	@autobind
	handleSubmit(event) {
		const name = event.target.name;
		const value = event.target.value;
		this.setState({
			...this.state,
			work: {
				...this.state.work,
				[name]: value
			}

		})
	}

	render() {
		return (
			<Fragment>
				<Button color="primary" onClick={this.toggle}>
					<i className='fa fa-edit'> </i>
				</Button>
				<Dialog
					toggle={this.toggle}
					confirm={this.confirm}
					isOpen={this.state.isOpen}
					title={'Arbeit bearbeiten'}
				>
					<Form>
						<FormGroup>
							<Label>
									Preis
							</Label>
							<Input type="number" step="0.01" name="price" value={this.state.work.price}
								onChange={this.handleSubmit}/>
						</FormGroup>
						<FormGroup>
							<Label>
									Datum
							</Label>
							<Input type="date" name="date" value={this.state.work.date}
								onChange={this.handleSubmit}/>
						</FormGroup>
						<FormGroup>
							<Label>
									Kommentar
							</Label>
							<Input type="textarea" name="comment" value={this.state.work.comment}
								onChange={this.handleSubmit}/>
						</FormGroup>
						<FormGroup>
							<Label>
									Verrechnet
							</Label>
							<Input type="select" name="verrechnet" value={this.state.work.verrechnet}
								onChange={this.handleSubmit}>
							<option value={0}>Nein</option>
							<option value={1}>Ja</option>
						</Input>
					</FormGroup>
				</Form>
			</Dialog>
		</Fragment>
		)
	}
}

@connect(
	state => {
		return {
			customers: state.customers,
			items: state.items
		}
	},
	dispatch => {
		return {
			fetchCustomer: (customer_id, callback) => {
				dispatch(customers.fetchCustomer(customer_id, callback))
			},
			add: (newWork) => dispatch(work.add(newWork))
		}
	}
)
export default class WorkList extends Component {


	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			customer: null,
			isNewWorkLogModalOpen: false,
			work_done: [],
			newWork: {
				date: getToday(),
				hours: '',
				comment: '',
				verrechnet: 0
			}
		};
	}

	componentDidMount() {
		this.fetchCustomer();
	}

	@autobind
	fetchCustomer() {
		const id = this.props.match.params.id;
		this.props.fetchCustomer(id, customer => {
			this.setState(
				{
					isLoading: false,
					customer: customer,
					work_done: customer.work_done,
					templateList: [
						{
							name: 'Anfahrtspauschale',
							price: customer.anfahrt,
						},
						{
							name: 'Unterweisung',
							price: customer.unterweisung,
						},
						{
							name: 'Hotelpauschale',
							price: customer.hotel_allowence
						},
						{
							name: 'Schulung',
							price: customer.instruction
						},
						{
							name: 'Jahresunterweisung - Arbeits- & Brandschutz',
							price: customer.instruction_yearly_work_safety + customer.instruction_yearly_fire_safety
						},
						{
							name: 'Jahresunterweisung - Arbeitsschutz',
							price: customer.instruction_yearly_work_safety
						},
						{
							name: 'Jahresunterweisung - Brandschutz',
							price: customer.instruction_yearly_fire_safety
						},
						{
							name: 'Materialpauschale Unterweisungen',
							price: customer.instruction_material_cost
						},
						{
							name: 'Betriebsanweisungen erstellt',
							price: customer.instructionmanual
						},
						{
							name: 'Betriebsanweisungen Kopie erstellt',
							price: customer.instructionmanualcopy
						},
						{
							name: 'Leiterprüfung',
							price: customer.ladder_exam
						},
						{
							name: 'Regalprüfung',
							price: customer.shelf_exam
						},
						{
							name: 'Brandschutzhelfer Ausbildung Theorie pro MA',
							price: customer.ausbildungbrandschutz
						},
						{
							name: 'Brandschutzunterweisung',
							price: customer.fire_protection_instruction
						},
						{
							name: 'Flucht & Rettungsplan erstellt',
							price: customer.escape_n_rescue_plan
						},
						{
							name: 'Reisekosten',
							price: ''
						},
					]
				}
			)
		})
	}

	@autobind
	confirmEditWork(work) {
		const index = this.state.work_done.findIndex(w => w.id === work.id);
		const work_done = [...this.state.work_done];
		work_done.splice(index, 1, work);
		this.setState({
			work_done: work_done
		})
	}

	@autobind
	deleteWork(work) {
		const index = this.state.work_done.findIndex(w => w.id === work.id);
		const work_done = [...this.state.work_done];
		work_done.splice(index, 1);
		this.setState({
			work_done: work_done
		})
	}

	@autobind
	chooseTemplate(event) {
		const idx = event.target.value;
		const template = this.state.templateList[idx];
		if(template) {
			this.setState({
				newWork: {
					...this.state.newWork,
					price: template.price,
					comment: template.name
				}
			}
			);
		}
	}

	render() {
		const id = this.props.match.params.id;
		if (this.state.isLoading)
			return <Loading/>;
		const customer = this.state.customer;
		const columnList = [
			{
				dataField: 'date',
				text: 'Datum',
				formatter: cell => <Date date={cell}/>
			},
			{
				dataField: 'price',
				text: 'Preis'
			},
			{
				dataField: 'comment',
				text: 'Kommentar'
			},
			{
				dataField: 'verrechnet',
				text: 'Verrechnet',
				formatter: cell => cell ? 'Ja' : 'Nein'
			},
			{
				dataField: 'id',
				text: '',
				isDummyField: true,
				formatter: (cell, row) =>
				<ButtonGroup>
					<EditWorkModal work={row} customer={customer} confirm={this.confirmEditWork}/>
					<DeleteWorkModal work={row} confirm={() => this.deleteWork(row)}/>
				</ButtonGroup>
			}

		];

		return (
			<DetailContainer id={id}>
				<h1>{customer.name}</h1>
				<InputGroup className="mb-3">
					<Button color="primary" onClick={this.toggleNewWorkLog}>
							Arbeit hinzufügen
					</Button>
					<ChangeYear nolabel/>
				</InputGroup>
				<Dialog
					toggle={this.toggleNewWorkLog}
					confirm={this.confirmNewWorkLog}
					isOpen={this.state.isNewWorkLogModalOpen}
					title={'Neue Arbeit hinzufügen'}
				>
					<Form onSubmit={this.confirmNewWorkLog}>
						<FormGroup>
							<Label>
									Vorlage
							</Label>
							<Input type="select" name="test" onChange={this.chooseTemplate}>
								<option>---</option>
									{
										this.state.templateList.map(
											(template, idx) => 
											<option key={`${idx}_template`} value={idx}>{ template.name }</option>
										)

									}
										</Input>
									</FormGroup>
									<FormGroup>
										<Label>
												Preis
										</Label>
										<Input type="number" step="0.01" name="price" value={this.state.newWork.price}
											onChange={this.handleSubmit}/>
									</FormGroup>
									<FormGroup>
										<Label>
												Datum
										</Label>
										<Input type="date" name="date" value={this.state.newWork.date}
											onChange={this.handleSubmit}/>
									</FormGroup>
									<FormGroup>
										<Label>
												Kommentar
										</Label>
										<Input type="textarea" name="comment" value={this.state.newWork.comment}
											onChange={this.handleSubmit}/>
									</FormGroup>
									<FormGroup>
										<Label>
												Verrechnet
										</Label>
										<Input type="select" name="verrechnet" value={this.state.newWork.verrechnet}
											onChange={this.handleSubmit}>
										<option value={0}>Nein</option>
										<option value={1}>Ja</option>
									</Input>
								</FormGroup>
							</Form>
						</Dialog>
						<BootstrapTable
							keyField='id'
							data={this.state.work_done}
							columns={columnList}
							bootstrap4
							responsive
						/>
						</DetailContainer>
		)
	}

	@autobind
	toggleNewWorkLog() {
		this.setState(
			{
				isNewWorkLogModalOpen: !this.state.isNewWorkLogModalOpen
			}
		)

	}

	@autobind
	confirmNewWorkLog() {
		const work = {
				...this.state.newWork,
				customer: this.state.customer.id
			}
		this.props.add(
			work
		);
		this.setState({isLoading: true});
		setTimeout(
			() => {
				this.fetchCustomer(
					customer => {
						this.setState({
							customer: customer,
							work_done: customer.work_done
						}, 
						)
					}
					);
				this.toggleNewWorkLog()
			}, 500
		)
	}

	@autobind
	handleSubmit(event) {
		const name = event.target.name;
		const value = event.target.value;
		this.setState({
			...this.state,
			newWork: {
				...this.state.newWork,
				[name]: value
			}
		})
	}
}

